"use client";

import { Hero } from "@/composites/landing";
import type { Cta, CmsImage } from "@/composites/landing/types";
import { useForwardedCta } from "@/app/utilities/query-params/use-forwarded-cta";

export interface InviteHeroBlock {
	blockType: "invite_hero";
	badge_text?: string;
	headline: string;
	subcopy?: string;
	primary_cta?: Cta;
}

/**
 * Adapter for the `invite_hero` block. Maps the typed CMS payload to the
 * `Hero` composite — no styling, no fetching.
 *
 * Runs in the browser so the CTA can pick up the visitor's `recruiterId`
 * from the URL while the page itself stays cached.
 */
export function InviteHero({ block }: { block: InviteHeroBlock }) {
	const withForwardedCta = useForwardedCta();

	return (
		<Hero
			eyebrow={block.badge_text}
			headline={block.headline}
			subcopy={block.subcopy}
			primaryCta={withForwardedCta(block.primary_cta)}
		/>
	);
}
